'use client';

import React, { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';

export default function ViewCounter({ views }: { views: number }) {
  const { data: session } = useSession();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const localRole = localStorage.getItem('userRole');
    const sessionRole = (session?.user as any)?.role || (session as any)?.role;
    if (localRole === 'administrator' || sessionRole === 'administrator') {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, [session]);

  if (!isAdmin) return null;

  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
      {views}
    </span>
  );
}
